<template>
  <summary
    @click.prevent
    class="group flex items-center justify-between bg-base-100 px-5 py-4 cursor-default select-none transition-all">
    <div class="flex items-center space-x-3">
      <component
        :is="icon"
        class="w-6 h-6 text-primary shrink-0 transition-transform duration-300 group-hover:scale-110 group-hover:-rotate-6"
        :class="{ wiggle: isHovered }"
        @mouseenter="$emit('update:hovering', sectionIndex)"
        @mouseleave="$emit('update:hovering', null)"
        aria-hidden="true" />
      <span class="text-xl font-semibold text-base-content">
        {{ title }}
      </span>
    </div>
    <svg
      class="w-5 h-5 text-primary transition-transform duration-300 group-hover:translate-x-1"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
    </svg>
  </summary>
</template>

<script setup lang="ts">
defineProps<{
  title: string;
  icon: any;
  sectionIndex: number;
  isHovered: boolean;
}>();

defineEmits<{
  (e: "update:hovering", hovering: number | null): void;
}>();
</script>
